import { render, staticRenderFns } from "./Scene4.vue?vue&type=template&id=ac0dab32&"
import script from "./Scene4.vue?vue&type=script&lang=js&"
export * from "./Scene4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports